var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"0.5","y1":"0.499","x2":"23.5","y2":"23.499","key":0}),React.createElement("line",{"x1":"23.5","y1":"0.499","x2":"0.5","y2":"23.499","key":1})]);
}

CloseInline.defaultProps = {"className":"stroke","viewBox":"0 0 24 24"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
